export interface AgentNodeData extends Record<string, unknown> {
  label: string
  roleDescription: string
  systemPrompt: string
  model: string
  toolList: string[]
  temperature: number
  isEntryPoint: boolean
  imageUrl?: string
}

export interface AgentNodePosition {
  x: number
  y: number
}

export interface AgentNode {
  id: string
  type: 'agent'
  position: AgentNodePosition
  data: AgentNodeData
  targetPosition?: 'top' | 'bottom' | 'left' | 'right'
  sourcePosition?: 'top' | 'bottom' | 'left' | 'right'
}

export interface AgentEdge {
  id: string
  source: string
  target: string
  label?: string
  type?: string
  animated?: boolean
}

export interface AgencyFlowState {
  nodeList: AgentNode[]
  edgeList: AgentEdge[]
  selectedNodeId: string | null
}

export const DEFAULT_AGENT_NODE_DATA: AgentNodeData = {
  label: 'New Agent',
  roleDescription: '',
  systemPrompt: '',
  model: 'anthropic/claude-sonnet-4',
  toolList: [],
  temperature: 0.3,
  isEntryPoint: false,
}

export const ENTRY_POINT_NODE_DATA: AgentNodeData = {
  label: 'Master Supervisor',
  roleDescription: '',
  systemPrompt: '',
  model: 'anthropic/claude-sonnet-4',
  toolList: [],
  temperature: 0.1,
  isEntryPoint: true,
}
